/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './notifyOfUpdate.defs.js'
export { main as default } from './notifyOfUpdate.defs.js'
